import { Directive, ElementRef, HostListener, Input, AfterViewInit } from '@angular/core';
import shave from "../utility/shave.js";

export class ShaveDirective implements AfterViewInit {

    windowSize: number;

    constructor(private el: ElementRef) { }

     shaveChar: string;
     shaveHeight: number;
     character: string;

    ngAfterViewInit() {
        this.windowSize = $(window).width();

        let lineHeight = Number($(this.el.nativeElement).css('line-height').replace('px', ''));
        
         
        shave(this.el.nativeElement, lineHeight * this.shaveHeight);
        let timer = null;
        $(window).on('resize', () => {
            
            if ($(window).width() == this.windowSize) return;
            this.windowSize = $(window).width();
            clearTimeout(timer);
            timer = setTimeout(() => {
                shave(this.el.nativeElement, lineHeight * this.shaveHeight);
            }, 200);
        })
    }
static ctorParameters() { return [ { type: ElementRef } ]; }}


// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../utility/shave.directive.ts